<div class="row ">
    <div class="col-sm-12">
      <div class="allColumns">
        <div class="column first-column" [@columnSize]="column_size == 'smaller' ? 'zero' : column_size">
          <ng-content select="firstColumn"></ng-content>
        </div>
        <div class="column second-column" [@columnSize]="column_size == 'large' ? 'lastlarge' : column_size">
          <ng-content select="secondColumn"></ng-content>
        </div>
        <div class="column" [@columnSize]="column_size == 'small' ? 'last' : column_size == 'smaller' ? column_size  : 'zero'">
          <ng-content select="thirdColumn"></ng-content>
        </div>
        <div class="column" [@columnSize]="column_size == 'smaller' ? 'last' : 'zero'">
          <ng-content select="fourthColumn"></ng-content>
        </div>
      </div>
    </div>
  </div>
  